module.exports = __webpack_public_path__ + "static/dire_wolf-491cfe02deea9c33834384511f0c870c.jpeg";